import Box from "@mui/material/Box"
import { useMediaQuery } from "@mui/material"
import Logo from "../new-components/Logo"
import { theme } from "@ikhokha/commons-ui"

import "./styles.css"
import MainWrapper from "./MainWrapper"

export default function PageWrapper({ child, childFooter }) {
	const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"))
	return (
		<MainWrapper
			isSmallScreen={isSmallScreen}
			child={
				<Box
					sx={
						isSmallScreen
							? {
									display: "flex",
									flexDirection: "column",
									alignItems: "center",
									width: "100%",
									marginTop: theme.spacing(4),
							  }
							: {
									display: "flex",
									flexDirection: "column",
									alignItems: "center",
									width: "100%",
									marginTop: theme.spacing(5),
							  }
					}
				>
					<Box
						sx={isSmallScreen ? { alignSelf: "flex-start", paddingLeft: theme.spacing(2) } : { marginBottom: theme.spacing(5) }}
					>
						<Logo />
					</Box>
					<Box
						sx={
							isSmallScreen
								? {
										alignSelf: "flex-start",
										borderRadius: "16px",
										boxSizing: "border-box",
										width: "100%",
										paddingRight: theme.spacing(2),
										paddingLeft: theme.spacing(2),
										paddingTop: theme.spacing(4),
								  }
								: {
										borderRadius: "16px",
										background: "#FFF",
										boxSizing: "border-box",
										width: "440px",
								  }
						}
					>
						{child}
					</Box>
				</Box>
			}
			childFooter={childFooter}
		/>
	)
}
